import { Component } from '@angular/core';
import { Usuario } from '../shared/index';
import { LoginService } from '../shared/service/login/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UsuarioService } from '../shared/service/usuario/usuario.service';
import { UtilService } from '../shared/service/util/util.service';

@Component({
    selector: 'app-redefinicao-otp',
    templateUrl: './redefinicao-otp.component.html',
    styleUrls: ['./redefinicao-otp.component.css']
})
export class RedefinicaoOtpComponent {

    public usuario : Usuario;
    public confirm : string;
    public urlAcesso : String;
    public mensagemPorTipo : string;
    public isTokenCartao : boolean;
    public idUsuario: number;
    public idOrganizacao: number;
    public tipoToken: string;
    
    constructor(
        private route: ActivatedRoute,
        private usuarioService: UsuarioService,
        private utilService: UtilService,
        private loginService: LoginService
    ) {

        this.route.params.subscribe(params => {
            const token = params["token"];
            this.tipoToken = token.split('.')[3].replace('tipo|', '');
            this.mensagemPorTipo = 'remoteID app';

            this.usuarioService.obterTokenInfoRedefinicaoToken(token).subscribe(
                res => {
                    if (res.possuiTokenCartao && this.tipoToken === 'CARTAO') 
                        this.mensagemPorTipo = 'Cartão de Nº ' + res.numeroCartao;

                }, error => {
                    this.utilService.showError(error.message);
                }
            );
        });
    }

    redefinir(){

        this.usuarioService.resetTokenOTP(this.route.snapshot.params.token).subscribe(
            res => {
                localStorage.setItem("message", "Seu e-Token foi redefinido.");
                this.loginService.logout();
            },
            err => {
                this.utilService.showError(err.message);
            }
        );
    }
}
